let startCursor = null;
let endCursor = null;
let searchQuery = null;
let searchDebounceTimer;
let searchResults;
let templateCard;

window.addEventListener('DOMContentLoaded', () => {
  const paginationContainer = document.querySelector('.js-filter-pagination');
  const prev = paginationContainer.querySelector('.previous');
  const next = paginationContainer.querySelector('.next');

  searchResults = document.getElementById('product-grid');
  templateCard = searchResults.querySelector('li');

  prev.addEventListener('click', (e) => {
    searchProducts('previous');
  });

  next.addEventListener('click', (e) => {
    searchProducts('next');
  });

  document.getElementById('searchInput').addEventListener('input', function () {
    clearTimeout(searchDebounceTimer);
    startCursor = endCursor = null; // Reset pagination cursors
    searchQuery = document.getElementById('searchInput').value;
    searchDebounceTimer = setTimeout(() => searchProducts(), 300); // Delay of 300ms to prevent excessive requests
  });
});

async function searchProducts(direction = 'next') {
  const token = '0809172ff136d323a0698dc87c10972c';
  const productsPerPage = document.querySelector('.js-collection-grid').dataset.productsPerPage || 16;

  const variables = {
    query: searchQuery ? `title:*${searchQuery}*` : '',
    after: direction === 'next' ? endCursor : null,
    before: direction === 'previous' ? startCursor : null,
    first: direction === 'next' ? productsPerPage : null,
    last: direction === 'previous' ? productsPerPage : null,
    sortKey: searchQuery ? null : 'TITLE',
    reverse: false,
  };

  const graphqlQuery = `
  query($query: String, $after: String, $before: String, $sortKey: ProductSortKeys, $reverse: Boolean) {
    shop {
      moneyFormat
    }
    products(first: ${variables.first}, last: ${variables.last}, query: $query, sortKey: $sortKey, reverse: $reverse, after: $after, before: $before) {
      edges {
        cursor
        node {
          id
          title
          handle
          vendor
          descriptionHtml
          images(first: 1) {
            edges {
              node {
                altText
                height
                width
                src
              }
            }
          }
          priceRange {
            maxVariantPrice {
              amount
              currencyCode
            }
            minVariantPrice {
              amount
              currencyCode
            }
          }
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }`;

  const response = await fetch('https://dermapure-clinical-uk.myshopify.com/api/2024-07/graphql.json', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Shopify-Storefront-Access-Token': token,
    },
    body: JSON.stringify({ query: graphqlQuery, variables }),
  });

  const result = await response.json();
  displayResults(result.data);
  updatePagination(result.data.products.pageInfo);
}

function displayResults(result) {
  searchResults.innerHTML = ''; // Clear previous results

  const { shop, products } = result;

  if (products.edges.length === 0) {
    searchResults.innerHTML = '<p>No products found</p>';
    return;
  }

  products.edges.forEach(({ node }) => {
    const { id, title, images, handle, priceRange, vendor, descriptionHtml } = node;
    const productId = id.split('/').pop();
    const clonedCard = templateCard.cloneNode(true);

    const formatPrice = (priceType) => {
      const { amount, currencyCode } = priceRange[priceType];
      return shop.moneyFormat.replace('{{amount}}', `${amount} ${currencyCode}`);
    };

    const regularPrice = clonedCard.querySelector('.price__regular .price-item');
    const salePrice = clonedCard.querySelector('.price__sale .price-item');
    const productImage = clonedCard.querySelector('.card__media img');

    if (regularPrice) regularPrice.innerHTML = formatPrice('maxVariantPrice');
    if (salePrice) salePrice.innerHTML = formatPrice('minVariantPrice');

    productImage.removeAttribute('srcset');
    productImage.src = images.edges[0]?.node.src || '';
    productImage.alt = title;

    clonedCard.querySelector('.card__product-vendor').textContent = vendor || '';
    clonedCard.querySelector('.card__heading a').textContent = title;
    clonedCard.querySelector('.card__heading a').href = `/products/${handle}`;
    clonedCard.querySelector('.card__description__text').innerHTML = descriptionHtml || '';
    clonedCard.querySelector('spark-product-card').setAttribute('parent-id', productId);

    searchResults.appendChild(clonedCard);
  });
}

function updatePagination(pageInfo) {
  const paginationContainer = document.querySelector('.js-filter-pagination');
  const paginationWrapper = document.querySelector('.pagination-wrapper');
  const prev = paginationContainer.querySelector('.previous');
  const next = paginationContainer.querySelector('.next');

  paginationContainer.classList.remove('hidden');
  paginationWrapper.classList.add('hidden');

  startCursor = pageInfo.startCursor;
  endCursor = pageInfo.endCursor;

  prev.disabled = !pageInfo.hasPreviousPage;
  next.disabled = !pageInfo.hasNextPage;
}
